{
  "accessibility": 59905,
  "accessibility-outline": 59906,
  "accessibility-sharp": 59907,
  "add": 59908,
  "add-circle": 59909,
  "add-circle-outline": 59910,
  "add-circle-sharp": 59911,
  "add-outline": 59912,
  "add-sharp": 59913,
  "airplane": 59914,
  "airplane-outline": 59915,
  "airplane-sharp": 59916,
  "alarm": 59917,
  "alarm-outline": 59918,
  "alarm-sharp": 59919,
  "albums": 59920,
  "albums-outline": 59921,
  "albums-sharp": 59922,
  "alert": 59923,
  "alert-circle": 59924,
  "alert-circle-outline": 59925,
  "alert-circle-sharp": 59926,
  "alert-outline": 59927,
  "alert-sharp": 59928,
  "american-football": 59929,
  "american-football-outline": 59930,
  "american-football-sharp": 59931,
  "analytics": 59932,
  "analytics-outline": 59933,
  "analytics-sharp": 59934,
  "aperture": 59935,
  "aperture-outline": 59936,
  "aperture-sharp": 59937,
  "apps": 59938,
  "apps-outline": 59939,
  "apps-sharp": 59940,
  "archive": 59941,
  "archive-outline": 59942,
  "archive-sharp": 59943,
  "arrow-back": 59944,
  "arrow-back-circle": 59945,
  "arrow-back-circle-outline": 59946,
  "arrow-back-circle-sharp": 59947,
  "arrow-back-outline": 59948,
  "arrow-back-sharp": 59949,
  "arrow-down": 59950,
  "arrow-down-circle": 59951,
  "arrow-down-circle-outline": 59952,
  "arrow-down-circle-sharp": 59953,
  "arrow-down-outline": 59954,
  "arrow-down-sharp": 59955,
  "arrow-forward": 59956,
  "arrow-forward-circle": 59957,
  "arrow-forward-circle-outline": 59958,
  "arrow-forward-circle-sharp": 59959,
  "arrow-forward-outline": 59960,
  "arrow-forward-sharp": 59961,
  "arrow-redo": 59962,
  "arrow-redo-circle": 59963,
  "arrow-redo-circle-outline": 59964,
  "arrow-redo-circle-sharp": 59965,
  "arrow-redo-outline": 59966,
  "arrow-redo-sharp": 59967,
  "arrow-undo": 59968,
  "arrow-undo-circle": 59969,
  "arrow-undo-circle-outline": 59970,
  "arrow-undo-circle-sharp": 59971,
  "arrow-undo-outline": 59972,
  "arrow-undo-sharp": 59973,
  "arrow-up": 59974,
  "arrow-up-circle": 59975,
  "arrow-up-circle-outline": 59976,
  "arrow-up-circle-sharp": 59977,
  "arrow-up-outline": 59978,
  "arrow-up-sharp": 59979,
  "at": 59980,
  "at-circle": 59981,
  "at-circle-outline": 59982,
  "at-circle-sharp": 59983,
  "at-outline": 59984,
  "at-sharp": 59985,
  "attach": 59986,
  "attach-outline": 59987,
  "attach-sharp": 59988,
  "backspace": 59989,
  "backspace-outline": 59990,
  "backspace-sharp": 59991,
  "bag": 59992,
  "bag-add": 59993,
  "bag-add-outline": 59994,
  "bag-add-sharp": 59995,
  "bag-check": 59996,
  "bag-check-outline": 59997,
  "bag-check-sharp": 59998,
  "bag-handle": 59999,
  "bag-handle-outline": 60000,
  "bag-handle-sharp": 60001,
  "bag-outline": 60002,
  "bag-remove": 60003,
  "bag-remove-outline": 60004,
  "bag-remove-sharp": 60005,
  "bag-sharp": 60006,
  "balloon": 60007,
  "balloon-outline": 60008,
  "balloon-sharp": 60009,
  "ban": 60010,
  "ban-outline": 60011,
  "ban-sharp": 60012,
  "bandage": 60013,
  "bandage-outline": 60014,
  "bandage-sharp": 60015,
  "bar-chart": 60016,
  "bar-chart-outline": 60017,
  "bar-chart-sharp": 60018,
  "barbell": 60019,
  "barbell-outline": 60020,
  "barbell-sharp": 60021,
  "barcode": 60022,
  "barcode-outline": 60023,
  "barcode-sharp": 60024,
  "baseball": 60025,
  "baseball-outline": 60026,
  "baseball-sharp": 60027,
  "basket": 60028,
  "basket-outline": 60029,
  "basket-sharp": 60030,
  "basketball": 60031,
  "basketball-outline": 60032,
  "basketball-sharp": 60033,
  "battery-charging": 60034,
  "battery-charging-outline": 60035,
  "battery-charging-sharp": 60036,
  "battery-dead": 60037,
  "battery-dead-outline": 60038,
  "battery-dead-sharp": 60039,
  "battery-full": 60040,
  "battery-full-outline": 60041,
  "battery-full-sharp": 60042,
  "battery-half": 60043,
  "battery-half-outline": 60044,
  "battery-half-sharp": 60045,
  "beaker": 60046,
  "beaker-outline": 60047,
  "beaker-sharp": 60048,
  "bed": 60049,
  "bed-outline": 60050,
  "bed-sharp": 60051,
  "beer": 60052,
  "beer-outline": 60053,
  "beer-sharp": 60054,
  "bicycle": 60055,
  "bicycle-outline": 60056,
  "bicycle-sharp": 60057,
  "bluetooth": 60058,
  "bluetooth-outline": 60059,
  "bluetooth-sharp": 60060,
  "boat": 60061,
  "boat-outline": 60062,
  "boat-sharp": 60063,
  "body": 60064,
  "body-outline": 60065,
  "body-sharp": 60066,
  "bonfire": 60067,
  "bonfire-outline": 60068,
  "bonfire-sharp": 60069,
  "book": 60070,
  "book-outline": 60071,
  "book-sharp": 60072,
  "bookmark": 60073,
  "bookmark-outline": 60074,
  "bookmark-sharp": 60075,
  "bookmarks": 60076,
  "bookmarks-outline": 60077,
  "bookmarks-sharp": 60078,
  "bowling-ball": 60079,
  "bowling-ball-outline": 60080,
  "bowling-ball-sharp": 60081,
  "briefcase": 60082,
  "briefcase-outline": 60083,
  "briefcase-sharp": 60084,
  "browsers": 60085,
  "browsers-outline": 60086,
  "browsers-sharp": 60087,
  "brush": 60088,
  "brush-outline": 60089,
  "brush-sharp": 60090,
  "bug": 60091,
  "bug-outline": 60092,
  "bug-sharp": 60093,
  "build": 60094,
  "build-outline": 60095,
  "build-sharp": 60096,
  "bulb": 60097,
  "bulb-outline": 60098,
  "bulb-sharp": 60099,
  "bus": 60100,
  "bus-outline": 60101,
  "bus-sharp": 60102,
  "business": 60103,
  "business-outline": 60104,
  "business-sharp": 60105,
  "cafe": 60106,
  "cafe-outline": 60107,
  "cafe-sharp": 60108,
  "calculator": 60109,
  "calculator-outline": 60110,
  "calculator-sharp": 60111,
  "calendar": 60112,
  "calendar-clear": 60113,
  "calendar-clear-outline": 60114,
  "calendar-clear-sharp": 60115,
  "calendar-number": 60116,
  "calendar-number-outline": 60117,
  "calendar-number-sharp": 60118,
  "calendar-outline": 60119,
  "calendar-sharp": 60120,
  "call": 60121,
  "call-outline": 60122,
  "call-sharp": 60123,
  "camera": 60124,
  "camera-outline": 60125,
  "camera-reverse": 60126,
  "camera-reverse-outline": 60127,
  "camera-reverse-sharp": 60128,
  "camera-sharp": 60129,
  "car": 60130,
  "car-outline": 60131,
  "car-sharp": 60132,
  "car-sport": 60133,
  "car-sport-outline": 60134,
  "car-sport-sharp": 60135,
  "card": 60136,
  "card-outline": 60137,
  "card-sharp": 60138,
  "caret-back": 60139,
  "caret-back-circle": 60140,
  "caret-back-circle-outline": 60141,
  "caret-back-circle-sharp": 60142,
  "caret-back-outline": 60143,
  "caret-back-sharp": 60144,
  "caret-down": 60145,
  "caret-down-circle": 60146,
  "caret-down-circle-outline": 60147,
  "caret-down-circle-sharp": 60148,
  "caret-down-outline": 60149,
  "caret-down-sharp": 60150,
  "caret-forward": 60151,
  "caret-forward-circle": 60152,
  "caret-forward-circle-outline": 60153,
  "caret-forward-circle-sharp": 60154,
  "caret-forward-outline": 60155,
  "caret-forward-sharp": 60156,
  "caret-up": 60157,
  "caret-up-circle": 60158,
  "caret-up-circle-outline": 60159,
  "caret-up-circle-sharp": 60160,
  "caret-up-outline": 60161,
  "caret-up-sharp": 60162,
  "cart": 60163,
  "cart-outline": 60164,
  "cart-sharp": 60165,
  "cash": 60166,
  "cash-outline": 60167,
  "cash-sharp": 60168,
  "cellular": 60169,
  "cellular-outline": 60170,
  "cellular-sharp": 60171,
  "chatbox": 60172,
  "chatbox-ellipses": 60173,
  "chatbox-ellipses-outline": 60174,
  "chatbox-ellipses-sharp": 60175,
  "chatbox-outline": 60176,
  "chatbox-sharp": 60177,
  "chatbubble": 60178,
  "chatbubble-ellipses": 60179,
  "chatbubble-ellipses-outline": 60180,
  "chatbubble-ellipses-sharp": 60181,
  "chatbubble-outline": 60182,
  "chatbubble-sharp": 60183,
  "chatbubbles": 60184,
  "chatbubbles-outline": 60185,
  "chatbubbles-sharp": 60186,
  "checkbox": 60187,
  "checkbox-outline": 60188,
  "checkbox-sharp": 60189,
  "checkmark": 60190,
  "checkmark-circle": 60191,
  "checkmark-circle-outline": 60192,
  "checkmark-circle-sharp": 60193,
  "checkmark-done": 60194,
  "checkmark-done-circle": 60195,
  "checkmark-done-circle-outline": 60196,
  "checkmark-done-circle-sharp": 60197,
  "checkmark-done-outline": 60198,
  "checkmark-done-sharp": 60199,
  "checkmark-outline": 60200,
  "checkmark-sharp": 60201,
  "chevron-back": 60202,
  "chevron-back-circle": 60203,
  "chevron-back-circle-outline": 60204,
  "chevron-back-circle-sharp": 60205,
  "chevron-back-outline": 60206,
  "chevron-back-sharp": 60207,
  "chevron-collapse": 60208,
  "chevron-collapse-outline": 60209,
  "chevron-collapse-sharp": 60210,
  "chevron-down": 60211,
  "chevron-down-circle": 60212,
  "chevron-down-circle-outline": 60213,
  "chevron-down-circle-sharp": 60214,
  "chevron-down-outline": 60215,
  "chevron-down-sharp": 60216,
  "chevron-expand": 60217,
  "chevron-expand-outline": 60218,
  "chevron-expand-sharp": 60219,
  "chevron-forward": 60220,
  "chevron-forward-circle": 60221,
  "chevron-forward-circle-outline": 60222,
  "chevron-forward-circle-sharp": 60223,
  "chevron-forward-outline": 60224,
  "chevron-forward-sharp": 60225,
  "chevron-up": 60226,
  "chevron-up-circle": 60227,
  "chevron-up-circle-outline": 60228,
  "chevron-up-circle-sharp": 60229,
  "chevron-up-outline": 60230,
  "chevron-up-sharp": 60231,
  "clipboard": 60232,
  "clipboard-outline": 60233,
  "clipboard-sharp": 60234,
  "close": 60235,
  "close-circle": 60236,
  "close-circle-outline": 60237,
  "close-circle-sharp": 60238,
  "close-outline": 60239,
  "close-sharp": 60240,
  "cloud": 60241,
  "cloud-circle": 60242,
  "cloud-circle-outline": 60243,
  "cloud-circle-sharp": 60244,
  "cloud-done": 60245,
  "cloud-done-outline": 60246,
  "cloud-done-sharp": 60247,
  "cloud-download": 60248,
  "cloud-download-outline": 60249,
  "cloud-download-sharp": 60250,
  "cloud-offline": 60251,
  "cloud-offline-outline": 60252,
  "cloud-offline-sharp": 60253,
  "cloud-outline": 60254,
  "cloud-sharp": 60255,
  "cloud-upload": 60256,
  "cloud-upload-outline": 60257,
  "cloud-upload-sharp": 60258,
  "cloudy": 60259,
  "cloudy-night": 60260,
  "cloudy-night-outline": 60261,
  "cloudy-night-sharp": 60262,
  "cloudy-outline": 60263,
  "cloudy-sharp": 60264,
  "code": 60265,
  "code-download": 60266,
  "code-download-outline": 60267,
  "code-download-sharp": 60268,
  "code-outline": 60269,
  "code-sharp": 60270,
  "code-slash": 60271,
  "code-slash-outline": 60272,
  "code-slash-sharp": 60273,
  "code-working": 60274,
  "code-working-outline": 60275,
  "code-working-sharp": 60276,
  "cog": 60277,
  "cog-outline": 60278,
  "cog-sharp": 60279,
  "color-fill": 60280,
  "color-fill-outline": 60281,
  "color-fill-sharp": 60282,
  "color-filter": 60283,
  "color-filter-outline": 60284,
  "color-filter-sharp": 60285,
  "color-palette": 60286,
  "color-palette-outline": 60287,
  "color-palette-sharp": 60288,
  "color-wand": 60289,
  "color-wand-outline": 60290,
  "color-wand-sharp": 60291,
  "compass": 60292,
  "compass-outline": 60293,
  "compass-sharp": 60294,
  "construct": 60295,
  "construct-outline": 60296,
  "construct-sharp": 60297,
  "contract": 60298,
  "contract-outline": 60299,
  "contract-sharp": 60300,
  "contrast": 60301,
  "contrast-outline": 60302,
  "contrast-sharp": 60303,
  "copy": 60304,
  "copy-outline": 60305,
  "copy-sharp": 60306,
  "create": 60307,
  "create-outline": 60308,
  "create-sharp": 60309,
  "crop": 60310,
  "crop-outline": 60311,
  "crop-sharp": 60312,
  "cube": 60313,
  "cube-outline": 60314,
  "cube-sharp": 60315,
  "cut": 60316,
  "cut-outline": 60317,
  "cut-sharp": 60318,
  "desktop": 60319,
  "desktop-outline": 60320,
  "desktop-sharp": 60321,
  "diamond": 60322,
  "diamond-outline": 60323,
  "diamond-sharp": 60324,
  "dice": 60325,
  "dice-outline": 60326,
  "dice-sharp": 60327,
  "disc": 60328,
  "disc-outline": 60329,
  "disc-sharp": 60330,
  "document": 60331,
  "document-attach": 60332,
  "document-attach-outline": 60333,
  "document-attach-sharp": 60334,
  "document-lock": 60335,
  "document-lock-outline": 60336,
  "document-lock-sharp": 60337,
  "document-outline": 60338,
  "document-sharp": 60339,
  "document-text": 60340,
  "document-text-outline": 60341,
  "document-text-sharp": 60342,
  "documents": 60343,
  "documents-outline": 60344,
  "documents-sharp": 60345,
  "download": 60346,
  "download-outline": 60347,
  "download-sharp": 60348,
  "duplicate": 60349,
  "duplicate-outline": 60350,
  "duplicate-sharp": 60351,
  "ear": 60352,
  "ear-outline": 60353,
  "ear-sharp": 60354,
  "earth": 60355,
  "earth-outline": 60356,
  "earth-sharp": 60357,
  "easel": 60358,
  "easel-outline": 60359,
  "easel-sharp": 60360,
  "egg": 60361,
  "egg-outline": 60362,
  "egg-sharp": 60363,
  "ellipse": 60364,
  "ellipse-outline": 60365,
  "ellipse-sharp": 60366,
  "ellipsis-horizontal": 60367,
  "ellipsis-horizontal-circle": 60368,
  "ellipsis-horizontal-circle-outline": 60369,
  "ellipsis-horizontal-circle-sharp": 60370,
  "ellipsis-horizontal-outline": 60371,
  "ellipsis-horizontal-sharp": 60372,
  "ellipsis-vertical": 60373,
  "ellipsis-vertical-circle": 60374,
  "ellipsis-vertical-circle-outline": 60375,
  "ellipsis-vertical-circle-sharp": 60376,
  "ellipsis-vertical-outline": 60377,
  "ellipsis-vertical-sharp": 60378,
  "enter": 60379,
  "enter-outline": 60380,
  "enter-sharp": 60381,
  "exit": 60382,
  "exit-outline": 60383,
  "exit-sharp": 60384,
  "expand": 60385,
  "expand-outline": 60386,
  "expand-sharp": 60387,
  "extension-puzzle": 60388,
  "extension-puzzle-outline": 60389,
  "extension-puzzle-sharp": 60390,
  "eye": 60391,
  "eye-off": 60392,
  "eye-off-outline": 60393,
  "eye-off-sharp": 60394,
  "eye-outline": 60395,
  "eye-sharp": 60396,
  "eyedrop": 60397,
  "eyedrop-outline": 60398,
  "eyedrop-sharp": 60399,
  "fast-food": 60400,
  "fast-food-outline": 60401,
  "fast-food-sharp": 60402,
  "female": 60403,
  "female-outline": 60404,
  "female-sharp": 60405,
  "file-tray": 60406,
  "file-tray-full": 60407,
  "file-tray-full-outline": 60408,
  "file-tray-full-sharp": 60409,
  "file-tray-outline": 60410,
  "file-tray-sharp": 60411,
  "file-tray-stacked": 60412,
  "file-tray-stacked-outline": 60413,
  "file-tray-stacked-sharp": 60414,
  "film": 60415,
  "film-outline": 60416,
  "film-sharp": 60417,
  "filter": 60418,
  "filter-circle": 60419,
  "filter-circle-outline": 60420,
  "filter-circle-sharp": 60421,
  "filter-outline": 60422,
  "filter-sharp": 60423,
  "finger-print": 60424,
  "finger-print-outline": 60425,
  "finger-print-sharp": 60426,
  "fish": 60427,
  "fish-outline": 60428,
  "fish-sharp": 60429,
  "fitness": 60430,
  "fitness-outline": 60431,
  "fitness-sharp": 60432,
  "flag": 60433,
  "flag-outline": 60434,
  "flag-sharp": 60435,
  "flame": 60436,
  "flame-outline": 60437,
  "flame-sharp": 60438,
  "flash": 60439,
  "flash-off": 60440,
  "flash-off-outline": 60441,
  "flash-off-sharp": 60442,
  "flash-outline": 60443,
  "flash-sharp": 60444,
  "flashlight": 60445,
  "flashlight-outline": 60446,
  "flashlight-sharp": 60447,
  "flask": 60448,
  "flask-outline": 60449,
  "flask-sharp": 60450,
  "flower": 60451,
  "flower-outline": 60452,
  "flower-sharp": 60453,
  "folder": 60454,
  "folder-open": 60455,
  "folder-open-outline": 60456,
  "folder-open-sharp": 60457,
  "folder-outline": 60458,
  "folder-sharp": 60459,
  "football": 60460,
  "football-outline": 60461,
  "football-sharp": 60462,
  "footsteps": 60463,
  "footsteps-outline": 60464,
  "footsteps-sharp": 60465,
  "funnel": 60466,
  "funnel-outline": 60467,
  "funnel-sharp": 60468,
  "game-controller": 60469,
  "game-controller-outline": 60470,
  "game-controller-sharp": 60471,
  "gift": 60472,
  "gift-outline": 60473,
  "gift-sharp": 60474,
  "git-branch": 60475,
  "git-branch-outline": 60476,
  "git-branch-sharp": 60477,
  "git-commit": 60478,
  "git-commit-outline": 60479,
  "git-commit-sharp": 60480,
  "git-compare": 60481,
  "git-compare-outline": 60482,
  "git-compare-sharp": 60483,
  "git-merge": 60484,
  "git-merge-outline": 60485,
  "git-merge-sharp": 60486,
  "git-network": 60487,
  "git-network-outline": 60488,
  "git-network-sharp": 60489,
  "git-pull-request": 60490,
  "git-pull-request-outline": 60491,
  "git-pull-request-sharp": 60492,
  "glasses": 60493,
  "glasses-outline": 60494,
  "glasses-sharp": 60495,
  "globe": 60496,
  "globe-outline": 60497,
  "globe-sharp": 60498,
  "golf": 60499,
  "golf-outline": 60500,
  "golf-sharp": 60501,
  "grid": 60502,
  "grid-outline": 60503,
  "grid-sharp": 60504,
  "hammer": 60505,
  "hammer-outline": 60506,
  "hammer-sharp": 60507,
  "hand-left": 60508,
  "hand-left-outline": 60509,
  "hand-left-sharp": 60510,
  "hand-right": 60511,
  "hand-right-outline": 60512,
  "hand-right-sharp": 60513,
  "happy": 60514,
  "happy-outline": 60515,
  "happy-sharp": 60516,
  "hardware-chip": 60517,
  "hardware-chip-outline": 60518,
  "hardware-chip-sharp": 60519,
  "headset": 60520,
  "headset-outline": 60521,
  "headset-sharp": 60522,
  "heart": 60523,
  "heart-circle": 60524,
  "heart-circle-outline": 60525,
  "heart-circle-sharp": 60526,
  "heart-dislike": 60527,
  "heart-dislike-circle": 60528,
  "heart-dislike-circle-outline": 60529,
  "heart-dislike-circle-sharp": 60530,
  "heart-dislike-outline": 60531,
  "heart-dislike-sharp": 60532,
  "heart-half": 60533,
  "heart-half-outline": 60534,
  "heart-half-sharp": 60535,
  "heart-outline": 60536,
  "heart-sharp": 60537,
  "help": 60538,
  "help-buoy": 60539,
  "help-buoy-outline": 60540,
  "help-buoy-sharp": 60541,
  "help-circle": 60542,
  "help-circle-outline": 60543,
  "help-circle-sharp": 60544,
  "help-outline": 60545,
  "help-sharp": 60546,
  "home": 60547,
  "home-outline": 60548,
  "home-sharp": 60549,
  "hourglass": 60550,
  "hourglass-outline": 60551,
  "hourglass-sharp": 60552,
  "ice-cream": 60553,
  "ice-cream-outline": 60554,
  "ice-cream-sharp": 60555,
  "id-card": 60556,
  "id-card-outline": 60557,
  "id-card-sharp": 60558,
  "image": 60559,
  "image-outline": 60560,
  "image-sharp": 60561,
  "images": 60562,
  "images-outline": 60563,
  "images-sharp": 60564,
  "infinite": 60565,
  "infinite-outline": 60566,
  "infinite-sharp": 60567,
  "information": 60568,
  "information-circle": 60569,
  "information-circle-outline": 60570,
  "information-circle-sharp": 60571,
  "information-outline": 60572,
  "information-sharp": 60573,
  "invert-mode": 60574,
  "invert-mode-outline": 60575,
  "invert-mode-sharp": 60576,
  "journal": 60577,
  "journal-outline": 60578,
  "journal-sharp": 60579,
  "key": 60580,
  "key-outline": 60581,
  "key-sharp": 60582,
  "keypad": 60583,
  "keypad-outline": 60584,
  "keypad-sharp": 60585,
  "language": 60586,
  "language-outline": 60587,
  "language-sharp": 60588,
  "laptop": 60589,
  "laptop-outline": 60590,
  "laptop-sharp": 60591,
  "layers": 60592,
  "layers-outline": 60593,
  "layers-sharp": 60594,
  "leaf": 60595,
  "leaf-outline": 60596,
  "leaf-sharp": 60597,
  "library": 60598,
  "library-outline": 60599,
  "library-sharp": 60600,
  "link": 60601,
  "link-outline": 60602,
  "link-sharp": 60603,
  "list": 60604,
  "list-circle": 60605,
  "list-circle-outline": 60606,
  "list-circle-sharp": 60607,
  "list-outline": 60608,
  "list-sharp": 60609,
  "locate": 60610,
  "locate-outline": 60611,
  "locate-sharp": 60612,
  "location": 60613,
  "location-outline": 60614,
  "location-sharp": 60615,
  "lock-closed": 60616,
  "lock-closed-outline": 60617,
  "lock-closed-sharp": 60618,
  "lock-open": 60619,
  "lock-open-outline": 60620,
  "lock-open-sharp": 60621,
  "log-in": 60622,
  "log-in-outline": 60623,
  "log-in-sharp": 60624,
  "log-out": 60625,
  "log-out-outline": 60626,
  "log-out-sharp": 60627,
  "logo-alipay": 60628,
  "logo-amazon": 60629,
  "logo-amplify": 60630,
  "logo-android": 60631,
  "logo-angular": 60632,
  "logo-apple": 60633,
  "logo-apple-appstore": 60634,
  "logo-apple-ar": 60635,
  "logo-behance": 60636,
  "logo-bitbucket": 60637,
  "logo-bitcoin": 60638,
  "logo-buffer": 60639,
  "logo-capacitor": 60640,
  "logo-chrome": 60641,
  "logo-closed-captioning": 60642,
  "logo-codepen": 60643,
  "logo-css3": 60644,
  "logo-designernews": 60645,
  "logo-deviantart": 60646,
  "logo-discord": 60647,
  "logo-docker": 60648,
  "logo-dribbble": 60649,
  "logo-dropbox": 60650,
  "logo-edge": 60651,
  "logo-electron": 60652,
  "logo-euro": 60653,
  "logo-facebook": 60654,
  "logo-figma": 60655,
  "logo-firebase": 60656,
  "logo-firefox": 60657,
  "logo-flickr": 60658,
  "logo-foursquare": 60659,
  "logo-github": 60660,
  "logo-gitlab": 60661,
  "logo-google": 60662,
  "logo-google-playstore": 60663,
  "logo-hackernews": 60664,
  "logo-html5": 60665,
  "logo-instagram": 60666,
  "logo-ionic": 60667,
  "logo-ionitron": 60668,
  "logo-javascript": 60669,
  "logo-laravel": 60670,
  "logo-linkedin": 60671,
  "logo-markdown": 60672,
  "logo-mastodon": 60673,
  "logo-medium": 60674,
  "logo-microsoft": 60675,
  "logo-no-smoking": 60676,
  "logo-nodejs": 60677,
  "logo-npm": 60678,
  "logo-octocat": 60679,
  "logo-paypal": 60680,
  "logo-pinterest": 60681,
  "logo-playstation": 60682,
  "logo-pwa": 60683,
  "logo-python": 60684,
  "logo-react": 60685,
  "logo-reddit": 60686,
  "logo-rss": 60687,
  "logo-sass": 60688,
  "logo-skype": 60689,
  "logo-slack": 60690,
  "logo-snapchat": 60691,
  "logo-soundcloud": 60692,
  "logo-stackoverflow": 60693,
  "logo-steam": 60694,
  "logo-stencil": 60695,
  "logo-tableau": 60696,
  "logo-tiktok": 60697,
  "logo-tumblr": 60698,
  "logo-tux": 60699,
  "logo-twitch": 60700,
  "logo-twitter": 60701,
  "logo-usd": 60702,
  "logo-venmo": 60703,
  "logo-vercel": 60704,
  "logo-vimeo": 60705,
  "logo-vk": 60706,
  "logo-vue": 60707,
  "logo-web-component": 60708,
  "logo-wechat": 60709,
  "logo-whatsapp": 60710,
  "logo-windows": 60711,
  "logo-wordpress": 60712,
  "logo-xbox": 60713,
  "logo-xing": 60714,
  "logo-yahoo": 60715,
  "logo-yen": 60716,
  "logo-youtube": 60717,
  "magnet": 60718,
  "magnet-outline": 60719,
  "magnet-sharp": 60720,
  "mail": 60721,
  "mail-open": 60722,
  "mail-open-outline": 60723,
  "mail-open-sharp": 60724,
  "mail-outline": 60725,
  "mail-sharp": 60726,
  "mail-unread": 60727,
  "mail-unread-outline": 60728,
  "mail-unread-sharp": 60729,
  "male": 60730,
  "male-female": 60731,
  "male-female-outline": 60732,
  "male-female-sharp": 60733,
  "male-outline": 60734,
  "male-sharp": 60735,
  "man": 60736,
  "man-outline": 60737,
  "man-sharp": 60738,
  "map": 60739,
  "map-outline": 60740,
  "map-sharp": 60741,
  "medal": 60742,
  "medal-outline": 60743,
  "medal-sharp": 60744,
  "medical": 60745,
  "medical-outline": 60746,
  "medical-sharp": 60747,
  "medkit": 60748,
  "medkit-outline": 60749,
  "medkit-sharp": 60750,
  "megaphone": 60751,
  "megaphone-outline": 60752,
  "megaphone-sharp": 60753,
  "menu": 60754,
  "menu-outline": 60755,
  "menu-sharp": 60756,
  "mic": 60757,
  "mic-circle": 60758,
  "mic-circle-outline": 60759,
  "mic-circle-sharp": 60760,
  "mic-off": 60761,
  "mic-off-circle": 60762,
  "mic-off-circle-outline": 60763,
  "mic-off-circle-sharp": 60764,
  "mic-off-outline": 60765,
  "mic-off-sharp": 60766,
  "mic-outline": 60767,
  "mic-sharp": 60768,
  "moon": 60769,
  "moon-outline": 60770,
  "moon-sharp": 60771,
  "move": 60772,
  "move-outline": 60773,
  "move-sharp": 60774,
  "musical-note": 60775,
  "musical-note-outline": 60776,
  "musical-note-sharp": 60777,
  "musical-notes": 60778,
  "musical-notes-outline": 60779,
  "musical-notes-sharp": 60780,
  "navigate": 60781,
  "navigate-circle": 60782,
  "navigate-circle-outline": 60783,
  "navigate-circle-sharp": 60784,
  "navigate-outline": 60785,
  "navigate-sharp": 60786,
  "newspaper": 60787,
  "newspaper-outline": 60788,
  "newspaper-sharp": 60789,
  "notifications": 60790,
  "notifications-circle": 60791,
  "notifications-circle-outline": 60792,
  "notifications-circle-sharp": 60793,
  "notifications-off": 60794,
  "notifications-off-circle": 60795,
  "notifications-off-circle-outline": 60796,
  "notifications-off-circle-sharp": 60797,
  "notifications-off-outline": 60798,
  "notifications-off-sharp": 60799,
  "notifications-outline": 60800,
  "notifications-sharp": 60801,
  "nuclear": 60802,
  "nuclear-outline": 60803,
  "nuclear-sharp": 60804,
  "nutrition": 60805,
  "nutrition-outline": 60806,
  "nutrition-sharp": 60807,
  "open": 60808,
  "open-outline": 60809,
  "open-sharp": 60810,
  "options": 60811,
  "options-outline": 60812,
  "options-sharp": 60813,
  "paper-plane": 60814,
  "paper-plane-outline": 60815,
  "paper-plane-sharp": 60816,
  "partly-sunny": 60817,
  "partly-sunny-outline": 60818,
  "partly-sunny-sharp": 60819,
  "pause": 60820,
  "pause-circle": 60821,
  "pause-circle-outline": 60822,
  "pause-circle-sharp": 60823,
  "pause-outline": 60824,
  "pause-sharp": 60825,
  "paw": 60826,
  "paw-outline": 60827,
  "paw-sharp": 60828,
  "pencil": 60829,
  "pencil-outline": 60830,
  "pencil-sharp": 60831,
  "people": 60832,
  "people-circle": 60833,
  "people-circle-outline": 60834,
  "people-circle-sharp": 60835,
  "people-outline": 60836,
  "people-sharp": 60837,
  "person": 60838,
  "person-add": 60839,
  "person-add-outline": 60840,
  "person-add-sharp": 60841,
  "person-circle": 60842,
  "person-circle-outline": 60843,
  "person-circle-sharp": 60844,
  "person-outline": 60845,
  "person-remove": 60846,
  "person-remove-outline": 60847,
  "person-remove-sharp": 60848,
  "person-sharp": 60849,
  "phone-landscape": 60850,
  "phone-landscape-outline": 60851,
  "phone-landscape-sharp": 60852,
  "phone-portrait": 60853,
  "phone-portrait-outline": 60854,
  "phone-portrait-sharp": 60855,
  "pie-chart": 60856,
  "pie-chart-outline": 60857,
  "pie-chart-sharp": 60858,
  "pin": 60859,
  "pin-outline": 60860,
  "pin-sharp": 60861,
  "pint": 60862,
  "pint-outline": 60863,
  "pint-sharp": 60864,
  "pizza": 60865,
  "pizza-outline": 60866,
  "pizza-sharp": 60867,
  "planet": 60868,
  "planet-outline": 60869,
  "planet-sharp": 60870,
  "play": 60871,
  "play-back": 60872,
  "play-back-circle": 60873,
  "play-back-circle-outline": 60874,
  "play-back-circle-sharp": 60875,
  "play-back-outline": 60876,
  "play-back-sharp": 60877,
  "play-circle": 60878,
  "play-circle-outline": 60879,
  "play-circle-sharp": 60880,
  "play-forward": 60881,
  "play-forward-circle": 60882,
  "play-forward-circle-outline": 60883,
  "play-forward-circle-sharp": 60884,
  "play-forward-outline": 60885,
  "play-forward-sharp": 60886,
  "play-outline": 60887,
  "play-sharp": 60888,
  "play-skip-back": 60889,
  "play-skip-back-circle": 60890,
  "play-skip-back-circle-outline": 60891,
  "play-skip-back-circle-sharp": 60892,
  "play-skip-back-outline": 60893,
  "play-skip-back-sharp": 60894,
  "play-skip-forward": 60895,
  "play-skip-forward-circle": 60896,
  "play-skip-forward-circle-outline": 60897,
  "play-skip-forward-circle-sharp": 60898,
  "play-skip-forward-outline": 60899,
  "play-skip-forward-sharp": 60900,
  "podium": 60901,
  "podium-outline": 60902,
  "podium-sharp": 60903,
  "power": 60904,
  "power-outline": 60905,
  "power-sharp": 60906,
  "pricetag": 60907,
  "pricetag-outline": 60908,
  "pricetag-sharp": 60909,
  "pricetags": 60910,
  "pricetags-outline": 60911,
  "pricetags-sharp": 60912,
  "print": 60913,
  "print-outline": 60914,
  "print-sharp": 60915,
  "prism": 60916,
  "prism-outline": 60917,
  "prism-sharp": 60918,
  "pulse": 60919,
  "pulse-outline": 60920,
  "pulse-sharp": 60921,
  "push": 60922,
  "push-outline": 60923,
  "push-sharp": 60924,
  "qr-code": 60925,
  "qr-code-outline": 60926,
  "qr-code-sharp": 60927,
  "radio": 60928,
  "radio-button-off": 60929,
  "radio-button-off-outline": 60930,
  "radio-button-off-sharp": 60931,
  "radio-button-on": 60932,
  "radio-button-on-outline": 60933,
  "radio-button-on-sharp": 60934,
  "radio-outline": 60935,
  "radio-sharp": 60936,
  "rainy": 60937,
  "rainy-outline": 60938,
  "rainy-sharp": 60939,
  "reader": 60940,
  "reader-outline": 60941,
  "reader-sharp": 60942,
  "receipt": 60943,
  "receipt-outline": 60944,
  "receipt-sharp": 60945,
  "recording": 60946,
  "recording-outline": 60947,
  "recording-sharp": 60948,
  "refresh": 60949,
  "refresh-circle": 60950,
  "refresh-circle-outline": 60951,
  "refresh-circle-sharp": 60952,
  "refresh-outline": 60953,
  "refresh-sharp": 60954,
  "reload": 60955,
  "reload-circle": 60956,
  "reload-circle-outline": 60957,
  "reload-circle-sharp": 60958,
  "reload-outline": 60959,
  "reload-sharp": 60960,
  "remove": 60961,
  "remove-circle": 60962,
  "remove-circle-outline": 60963,
  "remove-circle-sharp": 60964,
  "remove-outline": 60965,
  "remove-sharp": 60966,
  "reorder-four": 60967,
  "reorder-four-outline": 60968,
  "reorder-four-sharp": 60969,
  "reorder-three": 60970,
  "reorder-three-outline": 60971,
  "reorder-three-sharp": 60972,
  "reorder-two": 60973,
  "reorder-two-outline": 60974,
  "reorder-two-sharp": 60975,
  "repeat": 60976,
  "repeat-outline": 60977,
  "repeat-sharp": 60978,
  "resize": 60979,
  "resize-outline": 60980,
  "resize-sharp": 60981,
  "restaurant": 60982,
  "restaurant-outline": 60983,
  "restaurant-sharp": 60984,
  "return-down-back": 60985,
  "return-down-back-outline": 60986,
  "return-down-back-sharp": 60987,
  "return-down-forward": 60988,
  "return-down-forward-outline": 60989,
  "return-down-forward-sharp": 60990,
  "return-up-back": 60991,
  "return-up-back-outline": 60992,
  "return-up-back-sharp": 60993,
  "return-up-forward": 60994,
  "return-up-forward-outline": 60995,
  "return-up-forward-sharp": 60996,
  "ribbon": 60997,
  "ribbon-outline": 60998,
  "ribbon-sharp": 60999,
  "rocket": 61000,
  "rocket-outline": 61001,
  "rocket-sharp": 61002,
  "rose": 61003,
  "rose-outline": 61004,
  "rose-sharp": 61005,
  "sad": 61006,
  "sad-outline": 61007,
  "sad-sharp": 61008,
  "save": 61009,
  "save-outline": 61010,
  "save-sharp": 61011,
  "scale": 61012,
  "scale-outline": 61013,
  "scale-sharp": 61014,
  "scan": 61015,
  "scan-circle": 61016,
  "scan-circle-outline": 61017,
  "scan-circle-sharp": 61018,
  "scan-outline": 61019,
  "scan-sharp": 61020,
  "school": 61021,
  "school-outline": 61022,
  "school-sharp": 61023,
  "search": 61024,
  "search-circle": 61025,
  "search-circle-outline": 61026,
  "search-circle-sharp": 61027,
  "search-outline": 61028,
  "search-sharp": 61029,
  "send": 61030,
  "send-outline": 61031,
  "send-sharp": 61032,
  "server": 61033,
  "server-outline": 61034,
  "server-sharp": 61035,
  "settings": 61036,
  "settings-outline": 61037,
  "settings-sharp": 61038,
  "shapes": 61039,
  "shapes-outline": 61040,
  "shapes-sharp": 61041,
  "share": 61042,
  "share-outline": 61043,
  "share-sharp": 61044,
  "share-social": 61045,
  "share-social-outline": 61046,
  "share-social-sharp": 61047,
  "shield": 61048,
  "shield-checkmark": 61049,
  "shield-checkmark-outline": 61050,
  "shield-checkmark-sharp": 61051,
  "shield-half": 61052,
  "shield-half-outline": 61053,
  "shield-half-sharp": 61054,
  "shield-outline": 61055,
  "shield-sharp": 61056,
  "shirt": 61057,
  "shirt-outline": 61058,
  "shirt-sharp": 61059,
  "shuffle": 61060,
  "shuffle-outline": 61061,
  "shuffle-sharp": 61062,
  "skull": 61063,
  "skull-outline": 61064,
  "skull-sharp": 61065,
  "snow": 61066,
  "snow-outline": 61067,
  "snow-sharp": 61068,
  "sparkles": 61069,
  "sparkles-outline": 61070,
  "sparkles-sharp": 61071,
  "speedometer": 61072,
  "speedometer-outline": 61073,
  "speedometer-sharp": 61074,
  "square": 61075,
  "square-outline": 61076,
  "square-sharp": 61077,
  "star": 61078,
  "star-half": 61079,
  "star-half-outline": 61080,
  "star-half-sharp": 61081,
  "star-outline": 61082,
  "star-sharp": 61083,
  "stats-chart": 61084,
  "stats-chart-outline": 61085,
  "stats-chart-sharp": 61086,
  "stop": 61087,
  "stop-circle": 61088,
  "stop-circle-outline": 61089,
  "stop-circle-sharp": 61090,
  "stop-outline": 61091,
  "stop-sharp": 61092,
  "stopwatch": 61093,
  "stopwatch-outline": 61094,
  "stopwatch-sharp": 61095,
  "storefront": 61096,
  "storefront-outline": 61097,
  "storefront-sharp": 61098,
  "subway": 61099,
  "subway-outline": 61100,
  "subway-sharp": 61101,
  "sunny": 61102,
  "sunny-outline": 61103,
  "sunny-sharp": 61104,
  "swap-horizontal": 61105,
  "swap-horizontal-outline": 61106,
  "swap-horizontal-sharp": 61107,
  "swap-vertical": 61108,
  "swap-vertical-outline": 61109,
  "swap-vertical-sharp": 61110,
  "sync": 61111,
  "sync-circle": 61112,
  "sync-circle-outline": 61113,
  "sync-circle-sharp": 61114,
  "sync-outline": 61115,
  "sync-sharp": 61116,
  "tablet-landscape": 61117,
  "tablet-landscape-outline": 61118,
  "tablet-landscape-sharp": 61119,
  "tablet-portrait": 61120,
  "tablet-portrait-outline": 61121,
  "tablet-portrait-sharp": 61122,
  "telescope": 61123,
  "telescope-outline": 61124,
  "telescope-sharp": 61125,
  "tennisball": 61126,
  "tennisball-outline": 61127,
  "tennisball-sharp": 61128,
  "terminal": 61129,
  "terminal-outline": 61130,
  "terminal-sharp": 61131,
  "text": 61132,
  "text-outline": 61133,
  "text-sharp": 61134,
  "thermometer": 61135,
  "thermometer-outline": 61136,
  "thermometer-sharp": 61137,
  "thumbs-down": 61138,
  "thumbs-down-outline": 61139,
  "thumbs-down-sharp": 61140,
  "thumbs-up": 61141,
  "thumbs-up-outline": 61142,
  "thumbs-up-sharp": 61143,
  "thunderstorm": 61144,
  "thunderstorm-outline": 61145,
  "thunderstorm-sharp": 61146,
  "ticket": 61147,
  "ticket-outline": 61148,
  "ticket-sharp": 61149,
  "time": 61150,
  "time-outline": 61151,
  "time-sharp": 61152,
  "timer": 61153,
  "timer-outline": 61154,
  "timer-sharp": 61155,
  "today": 61156,
  "today-outline": 61157,
  "today-sharp": 61158,
  "toggle": 61159,
  "toggle-outline": 61160,
  "toggle-sharp": 61161,
  "trail-sign": 61162,
  "trail-sign-outline": 61163,
  "trail-sign-sharp": 61164,
  "train": 61165,
  "train-outline": 61166,
  "train-sharp": 61167,
  "transgender": 61168,
  "transgender-outline": 61169,
  "transgender-sharp": 61170,
  "trash": 61171,
  "trash-bin": 61172,
  "trash-bin-outline": 61173,
  "trash-bin-sharp": 61174,
  "trash-outline": 61175,
  "trash-sharp": 61176,
  "trending-down": 61177,
  "trending-down-outline": 61178,
  "trending-down-sharp": 61179,
  "trending-up": 61180,
  "trending-up-outline": 61181,
  "trending-up-sharp": 61182,
  "triangle": 61183,
  "triangle-outline": 61184,
  "triangle-sharp": 61185,
  "trophy": 61186,
  "trophy-outline": 61187,
  "trophy-sharp": 61188,
  "tv": 61189,
  "tv-outline": 61190,
  "tv-sharp": 61191,
  "umbrella": 61192,
  "umbrella-outline": 61193,
  "umbrella-sharp": 61194,
  "unlink": 61195,
  "unlink-outline": 61196,
  "unlink-sharp": 61197,
  "videocam": 61198,
  "videocam-off": 61199,
  "videocam-off-outline": 61200,
  "videocam-off-sharp": 61201,
  "videocam-outline": 61202,
  "videocam-sharp": 61203,
  "volume-high": 61204,
  "volume-high-outline": 61205,
  "volume-high-sharp": 61206,
  "volume-low": 61207,
  "volume-low-outline": 61208,
  "volume-low-sharp": 61209,
  "volume-medium": 61210,
  "volume-medium-outline": 61211,
  "volume-medium-sharp": 61212,
  "volume-mute": 61213,
  "volume-mute-outline": 61214,
  "volume-mute-sharp": 61215,
  "volume-off": 61216,
  "volume-off-outline": 61217,
  "volume-off-sharp": 61218,
  "walk": 61219,
  "walk-outline": 61220,
  "walk-sharp": 61221,
  "wallet": 61222,
  "wallet-outline": 61223,
  "wallet-sharp": 61224,
  "warning": 61225,
  "warning-outline": 61226,
  "warning-sharp": 61227,
  "watch": 61228,
  "watch-outline": 61229,
  "watch-sharp": 61230,
  "water": 61231,
  "water-outline": 61232,
  "water-sharp": 61233,
  "wifi": 61234,
  "wifi-outline": 61235,
  "wifi-sharp": 61236,
  "wine": 61237,
  "wine-outline": 61238,
  "wine-sharp": 61239,
  "woman": 61240,
  "woman-outline": 61241,
  "woman-sharp": 61242
}
